<template>
  <el-dialog :title="title" width="30%" :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-upload drag action="#" :auto-upload="false" :on-change="change" :show-file-list="false">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip">
        只能上传xlsx文件
        <!-- <el-button type="text" @click="download()">下载导入模板</el-button> -->
        <el-button type="primary" size="small" v-for="(item,index) in tableData" :key="index" @click="getExportTemplate(item.id)">{{ item.stockName }}</el-button>
      </div>
    </el-upload>
    <div v-if="file">{{ file.name }}</div>
    <span slot="footer">
      <el-button type="primary" @click="confirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  KSAXApiRequest,
  GetAllReseller
} from "../../../api/api";
export default {
  data() {
    return {
      dialogVisible: false,
      file: null,
      title: "",
      downloadUrl: "",
      tableData: [],
      // supId: null,
      type: null
    };
  },
  props: ['supId'],
  methods: {
    init(title, downloadUrl, type) {
      this.file = null;
      this.title = title
      this.downloadUrl = downloadUrl
      this.dialogVisible = true;
      this.type = type
      this.getAllReseller()
    },
    download() {
      window.open(this.downloadUrl);
    },
    change(e) {
      let index1 = e.raw.name.lastIndexOf(".") + 1;
      let index2 = e.raw.name.length;
      let type = e.raw.name.substring(index1, index2);
      if (type != "xlsx") {
        return this.$message.error("请上传文件格式为xlsx文件");
      }
      this.file = e.raw;
    },
    confirm() {
      this.$emit("confirm", this.file)
    },
    getAllReseller() {
      GetAllReseller({ SkipCount: 0, MaxResultCount: 10 }).then(res => {
        if (res.data.success) {
          // this.supId = res.data.result.items[0].remoteKey
          // let supId = res.data.result.items[0].remoteKey
          this.getMultistageStockList(this.supId)
        }
      })
    },
    getMultistageStockList(supId) {
      KSAXApiRequest({
        path: 'Product_MultistageStock/List',
        parmsJson: {
          level: 1,
          supId: supId,
          pageIndex: 1,
          pageSize: 100
        }
      }).then(res => {
        if (res.data.success) {
          this.tableData = res.data.response.data || []
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getExportTemplate(id) {
      let data = {
        supId: this.supId,
        stockId: id
      }
      if (this.type === 'modelCode') {
        data.isModelCode = true
      } 
      KSAXApiRequest({
        path: 'Product_MultistageStock/ExportStockTemplateList',
        parmsJson: data
      }).then(res => {
        if (res.data.success) {
          this.$message.success("请前往下载中心查看！")
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
  }
};
</script>